import { render, staticRenderFns } from "./projectsDocuments.vue?vue&type=template&id=0dccc549"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dccc549')) {
      api.createRecord('0dccc549', component.options)
    } else {
      api.reload('0dccc549', component.options)
    }
    module.hot.accept("./projectsDocuments.vue?vue&type=template&id=0dccc549", function () {
      api.rerender('0dccc549', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/projectsDocuments.vue"
export default component.exports